"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var configApi = exports.configApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: "/config",
      params: params
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/config/".concat(id, "/update"),
      data: data,
      method: "post"
    });
  },
  getParams: function getParams(params) {
    return (0, _request.default)({
      url: "/config/params",
      method: "get",
      params: params
    });
  }
};